import { render, staticRenderFns } from "./ValidateForm.vue?vue&type=template&id=16264547&scoped=true"
import script from "./ValidateForm.vue?vue&type=script&lang=js"
export * from "./ValidateForm.vue?vue&type=script&lang=js"
import style0 from "./ValidateForm.vue?vue&type=style&index=0&id=16264547&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16264547",
  null
  
)

export default component.exports